import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router, ROUTER_DIRECTIVES, ActivatedRoute } from '@angular/router';
import { IScenario, ScenarioService, UpdateCommitScenarioRequest, UpdateCommitScenarioResponse } from './scenario.service';
import { UserSession } from '../shared/user-session';
import {Messages} from 'primeng/primeng';
import { Dialog } from 'primeng/primeng';
import { UserInfoService } from '../shared/user-info.service';
import { AuthService } from '../authentication/auth.service';

@Component({
    template: require('./scenario-update.component.html'),
    styles: [require('../styles/faa_styles.css')],
    directives: [ROUTER_DIRECTIVES,Dialog],
    providers: [UpdateCommitScenarioRequest, UpdateCommitScenarioResponse]
})

    export class ScenarioUpdateComponent implements OnInit {
    pageTitle: string = 'Scenario Merge';
    serviceResponse: UpdateCommitScenarioResponse;
    errorMessage: string;
    currentScenario: IScenario;
    sourceScenarios: IScenario[];
    targetScenarios: IScenario[];
    allCheckbox: HTMLInputElement;
    towerWithoutRadarCheckbox: HTMLInputElement;
    traconCheckbox: HTMLInputElement;
    combinedTraconTowerCheckbox: HTMLInputElement;
    combinedNonRadarTowerCheckbox: HTMLInputElement;
    towerWithDisplayCheckbox: HTMLInputElement;
    combinedControlFacilityCheckbox: HTMLInputElement;
    towerWithRadarCheckbox: HTMLInputElement;
    enrouteCenterCheckbox: HTMLInputElement;
    combinedTraconCheckbox: HTMLInputElement;
    faaContractTowerCheckbox: HTMLInputElement;
    nonFaaFacilityCheckbox: HTMLInputElement;
    msgs: Messages[]=[];
    ownScenarios:string ="false";
    displaySpinner :boolean=false;
    allScenarios: IScenario[];
    scenarioHeaderDiv: HTMLDivElement;
    isScenarioOwner: boolean = false;


    constructor(private route: ActivatedRoute,
        private router: Router,
        private request: UpdateCommitScenarioRequest,
        private _scenarioService: ScenarioService,
        private _userInfoService: UserInfoService,
        private _User: UserSession,
        private authService: AuthService
    ) { }

    /*@ViewChild('all') all: ElementRef;
    @ViewChild('towerWithoutRadar') towerWithoutRadar: ElementRef;
    @ViewChild('tracon') tracon: ElementRef;
    @ViewChild('combinedTraconTower') combinedTraconTower: ElementRef;
    @ViewChild('combinedNonRadarTower') combinedNonRadarTower: ElementRef;
    @ViewChild('towerWithDisplay') towerWithDisplay: ElementRef;
    @ViewChild('combinedControlFacility') combinedControlFacility: ElementRef;
    @ViewChild('towerWithRadar') towerWithRadar: ElementRef;
    @ViewChild('enrouteCenter') enrouteCenter: ElementRef;
    @ViewChild('combinedTracon') combinedTracon: ElementRef;
    @ViewChild('faaContractTower') faaContractTower: ElementRef;
    @ViewChild('nonFaaFacility') nonFaaFacility: ElementRef;*/
    @ViewChild('scenarioHeader') scenarioHeader: ElementRef;

    ngOnInit() {

        // Setup default request object
        this.request.userId = this._User.userId;
        this.request.all = 1;
        this.request.towerWithoutRadar =1;
        this.request.tracon = 1;
        this.request.combinedTraconTower = 1;
        this.request.combinedNonRadarTower = 1;
        this.request.towerWithDisplay = 1;
        this.request.combinedControlFacility = 1;
        this.request.towerWithRadar = 1;
        this.request.enrouteCenter = 1;
        this.request.combinedTracon = 1;
        this.request.faaContractTower = 1;
        this.request.nonFaaFacility = 1;

        this.request.aopsFlag = 1;
        this.request.trFlag = 1;
        this.request.baFlag = 1;
        this.request.enplFlag = 1;
        this.request.preserveFlag = 1;

        this._scenarioService.getScenarios(this._User.getSession()['id'])
            .subscribe(
                scenarios => this.allScenarios = scenarios,
                error => this.errorMessage = <any>error,
               () => {
                if (this._User.hasValidSession()){
                    this.setScenarioHeader(this._User.getSession().scenarioId);
                  
                }
                else {
                    this.setScenarioHeader(this._User.scenarioId);
                    this._User.updateSessionState();
                }
            }
        );
        this.scenarioHeaderDiv = this.scenarioHeader.nativeElement;

        if(typeof(this._User.scenarioId) === 'undefined')
            this.router.navigate(['./scenario-activities']);

        console.log ("isScenarioOwner = " + this.isScenarioOwner + " ... isAdmin =  " + this._User.isAdmin);

        this._userInfoService.isScenarioOwner(this._User.getSession()['id'], this._User.getSession().scenarioId).subscribe(
            success =>{ this.isScenarioOwner = success.isOwner; 
                if(this.isScenarioOwner == false && this._User.isAdmin == false){
                    this.ownScenarios="false";
                    this.msgs = [];
                    this.msgs.push({severity:'warn', summary:'Warn Message', detail:'We\'re sorry,  your access level does not permit you to view this page. Contact the TAF administrator to change your access privileges.'});
                }
            },
            error => this.errorMessage = <any>error
        );

        //this probably needs to be somewhere more central
        this._User.updateSessionState();
        

        // Set list for Source scenarios
        this._scenarioService.getMergeListScenarios("source", this._User.userId)
            .subscribe(
                sourceScenarios => {
                    this.sourceScenarios = sourceScenarios;
                    if(this.sourceScenarios.length>0){
                        this.request.scenarioSourceId = this.sourceScenarios[0].id;
                        this.request.scenarioSourceName = this.sourceScenarios[0].scenarioName;
                        this.ownScenarios="true";
                        
                        // Bind HTML elements
                        //this.allCheckbox = this.all.nativeElement;

                        /*this.towerWithoutRadarCheckbox = this.towerWithoutRadar.nativeElement;
                        this.traconCheckbox = this.tracon.nativeElement;
                        this.combinedTraconTowerCheckbox = this.combinedTraconTower.nativeElement;
                        this.combinedNonRadarTowerCheckbox = this.combinedNonRadarTower.nativeElement;
                        this.towerWithDisplayCheckbox = this.towerWithDisplay.nativeElement;
                        this.combinedControlFacilityCheckbox = this.combinedControlFacility.nativeElement;
                        this.towerWithRadarCheckbox = this.towerWithRadar.nativeElement;
                        this.enrouteCenterCheckbox = this.enrouteCenter.nativeElement;
                        this.combinedTraconCheckbox = this.combinedTracon.nativeElement;
                        this.faaContractTowerCheckbox = this.faaContractTower.nativeElement;
                        this.nonFaaFacilityCheckbox = this.nonFaaFacility.nativeElement;*/
                    }
                    else{
                        this.ownScenarios="false";
                        this.msgs=[];
                        this.msgs.push({severity:'error', summary:'Error Message', 
                            detail: 'Sorry, you do not own any scenario.Please create one scenario if you would like to use this menu.' });
                    } 
            },
            error => this.errorMessage = <any>error
            );

        // Set list for Target Scenarios
        this._scenarioService.getMergeListScenarios("target", this._User.userId)
            .subscribe(
            targetScenarios => this.targetScenarios = targetScenarios,
            error => this.errorMessage = <any>error,
            () => {
                this.request.scenarioTargetId = this.targetScenarios[0].id;
                this.request.scenarioTargetName = this.targetScenarios[0].scenarioName;
            }
            );
    }
   private setScenarioHeader(scenarioId: number):void {
        let foundScenarios:IScenario[] = this.allScenarios.filter(function(scenario){
            return scenario.id === scenarioId;
        });
        if(foundScenarios.length > 0){
            this.currentScenario = foundScenarios[0];
        }
        this.scenarioHeaderDiv.innerHTML = `<strong>Current Scenario: ${this.currentScenario.scenarioName} (${this.currentScenario.id})</strong>`;
    }


    onSelectChange(event: Event, type: string) {
        let select: HTMLSelectElement = event.target as HTMLSelectElement;
        if (type == 'source') {
            this.request.scenarioSourceId = +select.value;
            this.request.scenarioSourceName = select.options[select.selectedIndex].innerHTML;
        }
        if (type == 'target') {
            this.request.scenarioTargetId = +select.value;
            this.request.scenarioTargetName = select.options[select.selectedIndex].innerHTML;
        }
    }
    onCheckboxChangeParam(event: Event) {
        let checkbox: HTMLInputElement = event.target as HTMLInputElement;
         switch (checkbox.id) {
             case 'aopsFlag':
                this.request.aopsFlag = checkbox.checked ? 1 : 0;
                break;
            case 'trFlag':
                this.request.trFlag = checkbox.checked ? 1 : 0;
                break;
            case 'baFlag':
                this.request.baFlag = checkbox.checked ? 1 : 0;
                break;
            case 'enplFlag':
                this.request.enplFlag = checkbox.checked ? 1 : 0;
                break;
            case 'preserveFlag':
                this.request.preserveFlag = checkbox.checked ? 1 : 0;
                break;
        }
    }
    onCheckboxChange(event: Event) {
        let checkbox: HTMLInputElement = event.target as HTMLInputElement;
        // If unchecking any checkbox other than all, unmark all checkbox
        if(checkbox.id !== 'all' && !checkbox.checked){
           // this.allCheckbox.checked = false;
           this.request.all =0;
        }
        // If checking all, check all other checkboxes 
        if(checkbox.id === 'all' && checkbox.checked){
           /* let checkboxes:HTMLInputElement[] = [
                this.towerWithoutRadarCheckbox,
                this.traconCheckbox,
                this.combinedTraconTowerCheckbox,
                this.combinedNonRadarTowerCheckbox,
                this.towerWithDisplayCheckbox,
                this.combinedControlFacilityCheckbox,
                this.towerWithRadarCheckbox,
                this.enrouteCenterCheckbox,
                this.combinedTraconCheckbox,
                this.faaContractTowerCheckbox,
                this.nonFaaFacilityCheckbox
            ];
            checkboxes.forEach(box => {
                box.checked = true;
            });*/
            this.request.all =1;
            this.request.towerWithoutRadar =1;
            this.request.tracon =1;
            this.request.combinedTraconTower =1;
            this.request.combinedNonRadarTower =1;
            this.request.towerWithDisplay =1;
            this.request.combinedControlFacility =1;
            this.request.towerWithRadar =1;
            this.request.enrouteCenter =1;
            this.request.combinedTracon =1;
            this.request.faaContractTower =1;
            this.request.nonFaaFacility =1;
           
        }

        // Set values for post
       /* switch (checkbox.id) {
            case 'all':
                this.request.all = checkbox.checked ? 1 : 0;
                break;
            case 'towerWithoutRadar':
                this.request.towerWithoutRadar = checkbox.checked ? 1 : 0;
                break;
            case 'tracon':
                this.request.tracon = checkbox.checked ? 1 : 0;
                break;
            case 'combinedTraconTower':
                this.request.combinedTraconTower = checkbox.checked ? 1 : 0;
                break;
            case 'combinedNonRadarTower':
                this.request.combinedNonRadarTower = checkbox.checked ? 1 : 0;
                break;
            case 'towerWithDisplay':
                this.request.towerWithDisplay = checkbox.checked ? 1 : 0;
                break;
            case 'combinedControlFacility':
                this.request.combinedControlFacility = checkbox.checked ? 1 : 0;
                break;
            case 'towerWithRadar':
                this.request.towerWithRadar = checkbox.checked ? 1 : 0;
                break;
            case 'enrouteCenter':
                this.request.enrouteCenter = checkbox.checked ? 1 : 0;
                break;
            case 'combinedTracon':
                this.request.combinedTracon = checkbox.checked ? 1 : 0;
                break;
            case 'faaContractTower':
                this.request.faaContractTower = checkbox.checked ? 1 : 0;
                break;
            case 'nonFaaFacility':
                this.request.nonFaaFacility = checkbox.checked ? 1 : 0;
                break;
            case 'aopsFlag':
                this.request.aopsFlag = checkbox.checked ? 1 : 0;
                break;
            case 'trFlag':
                this.request.trFlag = checkbox.checked ? 1 : 0;
                break;
            case 'baFlag':
                this.request.baFlag = checkbox.checked ? 1 : 0;
                break;
            case 'enplFlag':
                this.request.enplFlag = checkbox.checked ? 1 : 0;
                break;
            case 'preserveFlag':
                this.request.preserveFlag = checkbox.checked ? 1 : 0;
                break;
        }*/
    }

    applyChanges(): void {
        this.displaySpinner = true;
        //console.log("Update Scenario Apply Changes");
        //console.log(this.request);
        this._scenarioService.updateCommitScenario(this.request)
            .subscribe(
            response => this.serviceResponse = response,
            error => this.errorMessage = <any>error,
            () => {
                if (this.errorMessage) {
                    alert(this.errorMessage);
                    return;
                }
                if (this.serviceResponse.responseStatus === "ERROR") {
                    this.msgs=[];
                    this.msgs.push({severity:'error', summary:'Error Message', detail: this.serviceResponse.responseMessage });
                    this.displaySpinner = false;
                    return;
                }
                this.router.navigate(['./scenario-activities']);
            }
            );
    }

    cancel(): void {
        this.router.navigate(['./scenario-activities']);
    }
}


/** WEBPACK FOOTER **
 ** ./app/scenario-activities/scenario-update.component.ts
 **/